import { render, staticRenderFns } from "./DefaultInput.vue?vue&type=template&id=8fb467c6&scoped=true"
import script from "./DefaultInput.vue?vue&type=script&lang=js"
export * from "./DefaultInput.vue?vue&type=script&lang=js"
import style0 from "./DefaultInput.vue?vue&type=style&index=0&id=8fb467c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb467c6",
  null
  
)

export default component.exports